<template>
  <footer id="contact" class=" scrollElement" style="margin-top: 120px !important; ">
    <div class="my-bg "
         style=" background: url('/img/footer.png') top left no-repeat; background-size: 100% ;padding-bottom: 50px">

      <div class="px-lg-5" style=" padding-top: 100px">
        <div class="row px-5 ">
          <div class="col-xl-7 row mb-4">
            <div class="col-sm-6 col-xl-5 px-3">

              <div class="text-center mb-4">
                <img src="/img/logo.png" width="200px">
              </div>
              <small class="d-block text-justify">
                کوپاکافه یک برند اختصاصی شرکت آماده لذیذ در زمینه تولید قهوه است که با ارائه انواع قهوه، سعی دارد تا
                نیازهای مخاطبان خود را به بهترین شکل ممکن برآورده کند.
              </small>
            </div>
            <div class="col-sm-6 col-xl-7 px-lg-3" style="margin-top: 80px">
              <p class="text-center mb-4"><b>تماس با ما</b></p>

              <ul class="p-0">
                <li class="d-flex mb-3">
            <span class="me-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt"
                   viewBox="0 0 16 16">
                <path
                    d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z"/>
                <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
              </svg>
            </span>
                  <small>
                    <a target="_blank"
                       href="https://www.google.com/maps/place/AmadehLaziz/@35.7302329,51.3807302,19z/data=!4m6!3m5!1s0x3f8e07d020c7ca45:0x43bf4c9a730015f3!8m2!3d35.7301399!4d51.3807224!16s%2Fg%2F11c1r04p2q">
                      دفتر مرکزی: تهران، خیابان گیشا، خیابان هشتم، پلاک 58</a>
                  </small>
                </li>
                <li class="d-flex mb-3">
            <span class="me-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone"
                   viewBox="0 0 16 16">
                <path
                    d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
              </svg>
           </span>

                  <small dir="ltr">
                    <a href="tel:+982141638699">+98 21 41638699</a>

                  </small>
                </li>
                <li class="d-flex mb-3">
            <span class="me-2">
             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-postcard"
                  viewBox="0 0 16 16">
  <path fill-rule="evenodd"
        d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2ZM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4Zm7.5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7ZM2 5.5a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1-.5-.5ZM10.5 5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3ZM13 8h-2V6h2v2Z"/>
</svg>
           </span>

                  <small dir="ltr" style="cursor: pointer;position: relative" @click="coppyCode">
                    کد پستی:

                    <span id="postalcode">
                      1446863914
                    </span>
                    <!--                  <span id="coppyAlert">-->
                    <!--                      کپی شد!-->
                    <!--                    </span>-->
                  </small>
                </li>


              </ul>
            </div>
          </div>
          <div class="col-sm-5 col-xl-5 px-3 d-grid">
            <div class=" justify-content-between align-self-end d-none d-lg-flex">
              <div><img src="/img/c1.png" class="footer-img" alt=""></div>
              <div><img src="/img/c2.png" class="footer-img" alt=""></div>
              <div><img src="/img/c4.png" class="footer-img" alt=""></div>
              <div><img src="/img/c3.png" class="footer-img" alt=""></div>
            </div>
            <div class="d-lg-none d-flex">
              <div class="p-2"><img src="/img/c1.png" class="footer-img " alt=""></div>
              <div class="p-2"><img src="/img/c3.png" class="footer-img " alt=""></div>
            </div>
            <div class="d-lg-none d-flex">
              <div class="p-2"><img src="/img/c2.png" class="footer-img " alt=""></div>
              <div class="p-2"><img src="/img/c4.png" class="footer-img " alt=""></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <small class="d-block m-3 mx-5">
              &copy; کلیه حقوق این وبسایت متعلق به شرکت
              <br class="d-sm-none">
              آماده لذیذ میباشد.
            </small>
          </div>
        </div>
      </div>


    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>

</style>